import { render, staticRenderFns } from "./invoice_old.vue?vue&type=template&id=45465c88&"
import script from "./invoice_old.vue?vue&type=script&lang=js&"
export * from "./invoice_old.vue?vue&type=script&lang=js&"
import style0 from "./invoice_old.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports